<script>
import { defineComponent } from "@vue/composition-api";
import { Fragment } from "vue-fragment";

export default defineComponent({
  props: {
    isLoading: Boolean,
    className: String,
    variant: {
      type: String,
      default: "primary",
    },
  },
  setup() {},
  components: { Fragment },
});
</script>
<template>
  <Fragment>
    <b-button :class="className" @click="$emit('click')" :variant="variant" :disabled="isLoading">
      <b-spinner v-if="isLoading" small></b-spinner>
      <slot></slot>
    </b-button>
  </Fragment>
</template>
